import {
  ClientContactGetters,
  ClientContactMutations,
  ClientContactActions
} from '@/app/features/client-contacts/features/client-contact-details/client-contact-details.keys';
import { clientContactService } from '@/app/features/client-contacts/features/client-contact-details/client-contact-details.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { TolMessagesActions } from '@/app/features/tol-messages/tol-messages.keys';
import router from '@/router';

export const getDefaultState = () => {
  return {
    currentClientContact: {
      user: {},
      clients: [],
      address: {}
    },
    assignments: [],
    clientContactAssignmentSortOrder: {
      sortBy: 'payroll_number',
      sortDirection: 'asc'
    },
    clientContactValidationErrors: {}
  };
};
export const clientContactDetailsStore = {
  state: getDefaultState,
  getters: {
    [ClientContactGetters.GetClientContact]: state => state.currentClientContact,
    [ClientContactGetters.GetClientContactAssignments]: state => state.assignments,
    [ClientContactGetters.ClientContactAssignmentsSortOrder]: state =>
      state.clientContactAssignmentSortOrder,
    [ClientContactGetters.GetClientContactValidationErrors]: state =>
      state.clientContactValidationErrors
  },
  mutations: {
    [ClientContactMutations.SetClientContact](state, contactDetails) {
      state.currentClientContact = contactDetails;
    },
    [ClientContactMutations.SetClientContactAssignments](state, assignments) {
      state.assignments = assignments;
    },
    [ClientContactMutations.SetClientContactAssignmentSortOrder](state, sortOrder) {
      state.clientContactAssignmentSortOrder = sortOrder;
    },
    [ClientContactMutations.SetClientContactValidationErrors](state, errors) {
      state.clientContactValidationErrors = errors;
    }
  },
  actions: {
    [ClientContactActions.GetClientContact]({ commit }, reference_number) {
      clientContactService.getClientContact(reference_number).then(response => {
        commit(ClientContactMutations.SetClientContact, response.data);
      });
    },
    [ClientContactActions.GetClientContactAssignments]({ commit, state }, reference_number) {
      clientContactService
        .getClientContactAssignments(reference_number, state.clientContactAssignmentSortOrder)
        .then(response => {
          commit(ClientContactMutations.SetClientContactAssignments, response);
        });
    },
    [ClientContactActions.SetContractorAssignmentsSortOrder]: (
      { state, commit, dispatch },
      sortOrder
    ) => {
      commit(ClientContactMutations.SetClientContactAssignmentSortOrder, sortOrder);
      dispatch(
        ClientContactActions.GetClientContactAssignments,
        state.currentClientContact.user.reference_number
      );
    },
    [ClientContactActions.UpdateClientContactValidationErrors]: ({ commit }, errors = {}) => {
      commit(ClientContactMutations.SetClientContactValidationErrors, errors);
    },
    [ClientContactActions.SaveClientContact]({ dispatch }, clientContact) {
      clientContactService.saveClientContact(clientContact).then(status => {
        dispatch(TolErrorsActions.ClearAll);
        if (status && status.message === 'success') {
          dispatch(ClientContactActions.GetClientContact, clientContact.user.reference_number);
          router.replace({ path: `/client-contacts/${status.data}` });
          if (status.info) {
            dispatch(TolMessagesActions.SetMessages, status.info);
          }
        } else {
          dispatch(ClientContactActions.UpdateClientContactValidationErrors, status.errors);
          dispatch(TolMessagesActions.ClearAll);
          const messages = Object.values(status.errors);
          let items = [];
          for (let item of messages) {
            items = items.concat(item);
          }
          dispatch(TolErrorsActions.SetError, { items });
        }
      });
    }
  }
};
